import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class COEStockByDateReportService {
  constructor(private http: HttpUtilService) {}

  COEStockByDateReport(model: {
    StockAsOn: string;
    Type: string;
  }): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/COEStockByDateReport`,
      {
        model: model,
      },
    );
  }
}
